import { createRouter, createWebHistory } from 'vue-router'
import vuex from '@/store'
import { generateRoutes } from '@/utils/tools'

const routes = [
  {
    path: '',
    redirect: '/login'
  },
  {
    path: '/login',
    name: 'Login',
    meta: {
      auth: false
    },
    component: () => import('../views/login.vue')
  },
  {
    path: '/reg',
    name: 'Reg',
    meta: {
      auth: false
    },
    component: () => import('../views/reg.vue')
  },
  {
    path: '/appmain',
    name: 'AppMain',
    meta: {
      auth: true
    },
    component: () => import('../layout/AppMain.vue'),
    redirect:'/appmain/home',
    children: [
      {
        path: 'home',
        meta: {
          auth: true,
          keepalive: true,
          icon:'HomeFilled'
        },
        component: () => import('../views/home/index.vue')
      },
      {
        path: '/:pathMatch(.*)*',
        meta: {
          auth: false,
          keepalive:true,
        },
        component: () => import('../views/exception/error.vue')
      }
    ]
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

// 路由刷新标识
let registerRouteFresh = true

/** 全局前置路由守卫 */
router.beforeEach((to, from, next) => {
  if ((to.path !== '/login' && to.path !=='/reg') && registerRouteFresh) {
    // 获取vuex中存储的权限菜单信息
    const sidebarRouteData = vuex.state.permission.sidebarRoute

    // 将菜单信息转换为路由对象
    const routeArr = generateRoutes(sidebarRouteData)

    // 循环添加路由
    routeArr.forEach(v=>{
      // 依次添加路由对象，第一个参数为父级命名路由名称
      router.addRoute('AppMain', v)
    })

    // 更改路由刷新标识
    registerRouteFresh=false

    // 添加完路由再次触发一次路由跳转且设置替换
    next({...to,replace:true})

  } else {
    // 取token，有可能没有
    let token = vuex.state.permission.token

    if (token) {
      // 如果当前处于已登录状态，不允许跳转至登录界面
      if (to.path === '/login') {
        next({ path: '/appmain' })
      } else {
        next()// 放行
      }
    } else {
      // 检测是否需要鉴权
      if (to.meta.auth) {
        next({
          name: 'Login',
          params: {
            wantto: to.path
          }
        })
      } else {
        next()// 放行
      }
    }
  }

})

export default router
